/**
Author - Venkatesh Pullaganti😃
Git - https://github.com/venkatesh1146
**/

import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {triggerToast} from 'helpers';

import UploadTwoSidedDocument from './UploadTwoSidedDoc';

const propTypes = {
  onSubmitDocument: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  documentOptions: PropTypes.array,
  allowPasswordProtected: PropTypes.bool,
};

//FIXME: Use a single container for all the documents upload
const UploadTwoSidedDocumentContainer = ({
  onSubmitDocument,
  isLoading,
  heading,
  subHeading,
  documentOptions = [],
  allowPasswordProtected = true,
}) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const [password, setPassword] = useState({frontSide: '', backSide: ''});

  useEffect(() => {
    if (documentOptions.length) {
      setSelectedOption(documentOptions[0]);
    }
  }, [documentOptions]);

  useEffect(() => {
    if (uploadedFiles.length > 1) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [uploadedFiles]);

  const handleDeleteUploadedFile = (file) => {
    const filteredList = uploadedFiles.filter((eachFile) => eachFile.id !== file.id);
    setUploadedFiles(filteredList);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (uploadedFiles.length === 2) {
      const formData = new FormData();
      uploadedFiles.forEach((f) => formData.append(f.id, f));
      formData.append('front_doc_pass', password.frontSide);
      formData.append('back_doc_pass', password.backSide);

      if (selectedOption) {
        formData.append('document_type', selectedOption.key);
      }

      onSubmitDocument(formData);
    } else {
      triggerToast('Please add both front side and back side documents');
    }
  };

  const handleImageUpload = (files, side) => {
    let newFiles = [...uploadedFiles];

    // Remove previous file with same side
    newFiles = newFiles.filter((f) => f.id !== side);

    files.forEach((eachFile) => {
      eachFile.id = side;
      newFiles.push(eachFile);
    });

    setUploadedFiles([...newFiles]);
  };

  return (
    <UploadTwoSidedDocument
      handleImageUpload={handleImageUpload}
      handleDeleteUploadedFile={handleDeleteUploadedFile}
      isDisabled={isDisabled}
      isLoading={isLoading}
      uploadedFiles={uploadedFiles}
      onSubmit={onSubmit}
      heading={heading}
      subHeading={subHeading}
      documentOptions={documentOptions}
      allowPasswordProtected={allowPasswordProtected}
      setSelectedOption={setSelectedOption}
      selectedOption={selectedOption}
      password={password}
      setPassword={setPassword}
    />
  );
};

UploadTwoSidedDocumentContainer.propTypes = propTypes;

export default UploadTwoSidedDocumentContainer;
